<div class="warning-banner">
  {{ 'CUSTOMIZE_PARTNER.PRODUCT_NAMES.WARNING_MESSAGE' | translate }}
  <a routerLink="/marketplace/manage-products">
    {{ 'CUSTOMIZE_PARTNER.PRODUCT_NAMES.WARNING_LINK_MESSAGE' | translate }}
  </a>
  .
</div>

<form [formGroup]="namesGroup">
  <div class="form-elements">
    <forms-input [control]="namesGroup.get(['bcName'])" placeholder="Business App"></forms-input>
    <forms-input [control]="namesGroup.get(['nbName'])" placeholder="Brand Analytics"></forms-input>
  </div>
  <button mat-button (click)="saveNames()">
    {{ 'CUSTOMIZE_PARTNER.SHARED.APPLY_CHANGES' | translate }}
  </button>
  <button mat-button (click)="restoreDefault()" color="warn">
    {{ 'CUSTOMIZE_PARTNER.SHARED.RESTORE_DEFAULTS' | translate }}
  </button>
</form>
